import React, { useState } from 'react';

function SurveyStepTwentyEight({ formData, onNext }) {
    const [wellbeingRecommendation, setWellbeingRecommendation] = useState(formData.wellbeingRecommendation || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!wellbeingRecommendation.trim()) {
            setError('Please share your thoughts before continuing.');
            return;
        }
        setError('');
        onNext({ wellbeingRecommendation });
    };

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 6: Employee Well-being</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                Would you recommend this company to others based on its focus on well-being? <span className="text-danger">*</span>
            </label>

            <textarea
                className="form-control"
                rows="6"
                value={wellbeingRecommendation}
                onChange={(e) => setWellbeingRecommendation(e.target.value)}
                placeholder="Share your thoughts here..."
            />

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!wellbeingRecommendation.trim()}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepTwentyEight;
